import React, {
  useContext,
  useEffect,
  useState,
} from "react";

import {
  TranslatorContext,
} from "../../context/Translator";

import {
  Link,
} from "react-router-dom";

import {
  Row,
  Col,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";

import TotalGroupsRecord from "./TotalGroupsRecord";
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import GroupDashboardCharts from "./GroupDashboardCharts";


export default function GroupDashboard() {

  const AuthToken =
    localStorage.getItem(
      "AuthUser"
    );


  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${AuthToken}`;


  const { t } =
    useContext(
      TranslatorContext
    );


  /*
  |--------------------------------------------------------------------------
  | STATES
  |--------------------------------------------------------------------------
  */

  const [
    formState,
    setFormState
  ] = useState({

    from: "",
    to: "",

  });


  const [
    error,
    setError
  ] = useState("");


  const [
    data,
    setData
  ] = useState(null);


  const [
    loading,
    setLoading
  ] = useState(true);


  /*
  |--------------------------------------------------------------------------
  | FETCH DASHBOARD
  |--------------------------------------------------------------------------
  */

  const fetchDashboard =
    async (
      params = {}
    ) => {

      try {

        setLoading(true);

        setError("");


        const response =
          await axios.get(

            process.env
              .REACT_APP_API_URL +
              "/act-group-dashboard",

            {
              params,
            }

          );


        if (
          response.data.success
        ) {

          setData(
            response.data.data
          );

        }


      } catch (error) {

        console.error(
          "ACT Dashboard Error:",
          error
        );


        setError(

          error.response
            ?.data
            ?.message ||

          "Unable to load ACT dashboard."

        );


      } finally {

        setLoading(false);

      }

    };


  /*
  |--------------------------------------------------------------------------
  | INITIAL LOAD
  |--------------------------------------------------------------------------
  */

  useEffect(() => {

    fetchDashboard();

  }, []);


  /*
  |--------------------------------------------------------------------------
  | CHANGE
  |--------------------------------------------------------------------------
  */

  const handleChange =
    (e) => {

      const {
        name,
        value,
      } = e.target;


      const updated = {

        ...formState,

        [name]:
          value,

      };


      setFormState(
        updated
      );


      if (
        updated.from &&
        updated.to
      ) {

        if (
          new Date(
            updated.to
          ) >=
          new Date(
            updated.from
          )
        ) {

          setError("");

        }

      } else {

        setError("");

      }

    };


  /*
  |--------------------------------------------------------------------------
  | APPLY FILTER
  |--------------------------------------------------------------------------
  */

  const handleApplyFilter =
    async () => {

      const {
        from,
        to,
      } = formState;


      if (
        !from &&
        !to
      ) {

        setError(
          "Please enter From Date and To Date."
        );

        return;
      }


      if (
        from &&
        !to
      ) {

        setError(
          "Please select a 'To Date' when 'From Date' is chosen."
        );

        return;
      }


      if (
        !from &&
        to
      ) {

        setError(
          "Please select a 'From Date' when 'To Date' is chosen."
        );

        return;
      }


      if (
        new Date(to) <
        new Date(from)
      ) {

        setError(
          "'To Date' cannot be earlier than 'From Date'."
        );

        return;
      }


      setError("");


      await fetchDashboard({

        from,
        to,

      });

    };


  /*
  |--------------------------------------------------------------------------
  | CLEAR FILTER
  |--------------------------------------------------------------------------
  */

  const handleClearFilter =
    async () => {

      setFormState({

        from: "",
        to: "",

      });


      setError("");


      await fetchDashboard();

    };


  /*
  |--------------------------------------------------------------------------
  | VIEW
  |--------------------------------------------------------------------------
  */

  return (

    <PageLayout>

      <Row>


        {/* =====================================================
            BREADCRUMB
        ===================================================== */}

        <Col xl={12}>

          <div className="mc-card">

            <div className="mc-breadcrumb">

              <h3 className="mc-breadcrumb-title">

                ACT Groups

              </h3>


              <ul className="mc-breadcrumb-list">

                <li className="mc-breadcrumb-item">

                  <Link
                    to="#"
                    className="mc-breadcrumb-link"
                    style={{
                      color:
                        "#077834",
                    }}
                  >

                    {t("home")}

                  </Link>

                </li>


                <li className="mc-breadcrumb-item">

                  ACT Groups Dashboard

                </li>

              </ul>

            </div>

          </div>

        </Col>


        {/* =====================================================
            FILTER
        ===================================================== */}

        <Col xl={12}>

          <div className="mc-card">

            <div
              className="mc-breadcrumb"
              style={{
                marginBottom:
                  "10px",
              }}
            >

              <h3 className="mc-breadcrumb-title">

                SELECT FILTER RANGE DATA

              </h3>

            </div>


            <Row
              className="align-items-center g-3"
            >


              <Col md="auto">

                <Form.Label className="mb-0">

                  From:

                </Form.Label>

              </Col>


              <Col md={3}>

                <Form.Control
                  type="date"
                  name="from"
                  value={
                    formState.from
                  }
                  onChange={
                    handleChange
                  }
                />

              </Col>


              <Col md="auto">

                <Form.Label className="mb-0">

                  To:

                </Form.Label>

              </Col>


              <Col md={3}>

                <Form.Control
                  type="date"
                  name="to"
                  value={
                    formState.to
                  }
                  onChange={
                    handleChange
                  }
                />

              </Col>


              <Col md={2}>

                <Button
                  onClick={
                    handleApplyFilter
                  }
                  disabled={
                    loading
                  }
                  style={{

                    backgroundColor:
                      "#077834",

                    borderColor:
                      "#077834",

                    fontWeight:
                      "bold",

                    fontSize:
                      "12px",

                  }}
                >

                  Apply Filter

                </Button>

              </Col>


              <Col md={2}>

                <Button
                  onClick={
                    handleClearFilter
                  }
                  disabled={
                    loading
                  }
                  variant="secondary"
                  style={{

                    fontWeight:
                      "bold",

                    fontSize:
                      "12px",

                  }}
                >

                  Clear Filter

                </Button>

              </Col>

            </Row>


            {error && (

              <div
                className="text-danger mt-2"
                style={{
                  fontSize:
                    "13px",
                }}
              >

                {error}

              </div>

            )}

          </div>

        </Col>


        {/* =====================================================
            LOADING
        ===================================================== */}

        {loading &&
          !data && (

          <Col xs={12}>

            <div className="text-center py-5">

              <Spinner
                animation="border"
                variant="success"
              />

              <div className="mt-2">

                Loading Dashboard...

              </div>

            </div>

          </Col>

        )}


        {/* =====================================================
            CARDS
        ===================================================== */}

        {data && (

          <Col
            xs={12}
            xl={12}
          >

            <Row
              xs={1}
              sm={2}
            >

              <TotalGroupsRecord
                data={data}
              />

            </Row>

          </Col>

        )}


        {/* =====================================================
            CHARTS
        ===================================================== */}

        {data && (

          <Col
            xs={12}
            xl={12}
          >

            <GroupDashboardCharts
              data={data}
            />

          </Col>

        )}

      </Row>

    </PageLayout>

  );
}